import { ThemeColorsKeys } from '../../styles/tokens/colors';

export default {
  circleBorderColor: 'utilityWhite',
} as Record<string, ThemeColorsKeys>;
